import { render, staticRenderFns } from "./signature.vue?vue&type=template&id=17944c1a"
import script from "./signature.vue?vue&type=script&lang=js"
export * from "./signature.vue?vue&type=script&lang=js"
import style0 from "./signature.vue?vue&type=style&index=0&id=17944c1a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17944c1a')) {
      api.createRecord('17944c1a', component.options)
    } else {
      api.reload('17944c1a', component.options)
    }
    module.hot.accept("./signature.vue?vue&type=template&id=17944c1a", function () {
      api.rerender('17944c1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/signature.vue"
export default component.exports